<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

appStore.initTheme()
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{namespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}

.el-scrollbar {
  height: 100% !important;
}
.el-card {
  border: 1px solid var(--top-header-hover-color) !important;
}

// 表格圆角
.el-table {
  border: 1px solid var(--el-table-border-color) !important;
  border-radius: 10px;
}

.el-table--border .el-table__inner-wrapper::after,
.el-table__border-left-patch,
.el-table--border::before,
.el-table--border::after,
.el-table__inner-wrapper::before {
  display: none !important;
}
.el-table--border .el-table__cell {
  &:last-child {
    border-right: none !important;
  }
}
.el-table .el-table__row:last-child td.el-table__cell {
  border-bottom: none !important;
}
.el-dialog {
  border-radius: 10px !important;
}
</style>
